// extracted by mini-css-extract-plugin
module.exports =  {"body":"DateTimeView-module__body___hicBt","date":"DateTimeView-module__date___QVUdf","time":"DateTimeView-module__time___wlxg8"};